import Image from "next/image";
import type { ReactEventHandler } from "react";
import { getResponsivePoster } from "@/lib/responsive-poster";

/** Pre-encoded still frames keep cold edge transforms out of the hero's critical path. */
export function CcResponsivePoster({ src, sizes, className, alt = "", first = false, fill = false, onLoad }: {
  src: string; sizes: string; className?: string; alt?: string; first?: boolean; fill?: boolean; onLoad?: ReactEventHandler<HTMLImageElement>;
}) {
  const poster = getResponsivePoster(src);
  const style = fill ? { position: "absolute" as const, inset: 0, width: "100%", height: "100%", objectFit: "cover" as const } : undefined;
  if (!poster) return <Image src={src} alt={alt} fill sizes={sizes} className={className} style={{ objectFit: "cover" }} loading={first ? "eager" : "lazy"} fetchPriority={first ? "high" : "low"} onLoad={onLoad} />;
  const fallback = poster.fallback;
  return <picture>
    <source type="image/avif" srcSet={poster.avifSrcSet} sizes={sizes} />
    <source type="image/webp" srcSet={poster.webpSrcSet} sizes={sizes} />
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img src={fallback.src} srcSet={poster.webpSrcSet} sizes={sizes} className={className} style={style} width={fallback.width} height={fallback.height} alt={alt} loading={first ? "eager" : "lazy"} fetchPriority={first ? "high" : "low"} decoding="async" onLoad={onLoad} />
  </picture>;
}
